import { makeStyles } from '@material-ui/core'

import { getFont } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  dayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    width: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      height: 70,
      fontSize: 14,
      width: 100,
      color: 'gray',
      borderLeft: `1px solid ${
        theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
      }`,
      borderBottom: `1px solid ${
        theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
      }`,
      boxSizing: 'border-box'
    },
    '& input': {
      fontSize: 12,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
      fontFamily: getFont()
    }
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  },
  status: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  normalStatus: {
    background: theme.palette.success.main
  },
  warningStatus: {
    background: theme.palette.warning.main
  },
  criticalStatus: {
    background: theme.palette.error.main
  },
  unexpectedStatus: {
    background: theme.palette.info.main
  },
  textTimeTwoWeeks: {
    fontSize: 12,
    color: theme.palette.primary.contrastText
  },
  textTimeMonth: {
    fontSize: 9,
    color: theme.palette.primary.contrastText
  }
}))
export default useStyles
